import React, { useState, useRef, useEffect, useContext } from "react";
import { Tab, Menu } from 'semantic-ui-react'
import { useSelector, useDispatch } from 'react-redux'
import { UpComing, OnGoing, ContestList } from '../components'
import { setTab } from '../store/UserRedux'

const ContestTab = () => {
  const tabActive = useSelector((state) => state.user.tab)
  const [tab, setTabs] = useState(tabActive)
  const dispatch = useDispatch()

  const panes = [
    {
      menuItem: (
        <Menu.Item key='Ongoing'>
          <div>Ongoing</div><div className="yellow_border"></div>
        </Menu.Item>
      ),
      render: () => <Tab.Pane>
        <OnGoing isSearch={true} />
      </Tab.Pane>
    },
    {
      menuItem: (
        <Menu.Item key='Upcoming'>
          <div>Upcoming</div><div className="yellow_border"></div>
        </Menu.Item>
      ),
      render: () => <Tab.Pane>
        <UpComing isSearch={true} />
      </Tab.Pane>
    },
    { 
      menuItem: (
        <Menu.Item key='Completed'>
          <div>Completed</div><div className="yellow_border"></div>
        </Menu.Item>
      ),
      render: () => <Tab.Pane>
        <ContestList isStatus={'completed'} />
      </Tab.Pane>
    },
  ]

  return (
    <>
      <div className="tab_sec clearall"> <Tab activeIndex={tab} onTabChange={((e, { activeIndex }) => { setTabs(activeIndex); dispatch(setTab(activeIndex)) })} panes={panes} /></div>
    </>
  );
};



export default ContestTab;
